import {
  TextInput,
  Grid,
  Stack,
  ScrollArea,
  Button,
  Select,
  LoadingOverlay,
  PasswordInput,
  Tabs,
  SimpleGrid,
} from "@mantine/core";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { showNotification } from "@mantine/notifications";
import { useForm } from "@mantine/form";
import { useViewportSize } from "@mantine/hooks";
import {
  CREATE_SUPPLIER,
  CREATE_SUPPLIER_Business,
  UPDATE_BasicSupplierBusinessInfo,
} from "apollo/mutuations";
import {
  GET_MY_SUPPLIERS_Business,
  GET_REGIONS,
  GET_SUPPLIERS,
} from "apollo/queries";
import { customLoader } from "components/utilities/loader";
import { useMemo } from "react";
import { useRef } from "react";
import {
  useLoadScript,
  GoogleMap,
  MarkerF,
  Autocomplete,
} from "@react-google-maps/api";
import ContentLoader from "react-content-loader";
const Loader = () => (
  <ContentLoader
    width="100%"
    height={400}
    backgroundColor="#f0f0f0"
    foregroundColor="#dedede"
  >
    <rect width="100%" height="400px" />
  </ContentLoader>
);

const containerStyle = {
  width: "100%",
  height: "400px",
};
const GOOGLE_API_KEY = "AIzaSyARVREQA1z13d_alpkPt_LW_ajP_VfFiGk";
const libraries = ["places"];
const SupplierBusinessUpdateModal = ({ setOpened, size, activePage, data }) => {
  const [location, setLocation] = useState({});
  const [center, setCenter] = useState({ lat: 8.9999645, lng: 38.7700539 });
  const [autocomplete, setAutocomplete] = useState();
  const [regionsDropDownData, setRegionsDropDownData] = useState([]);

  const [mapRef, setMapRef] = useState(null);
  const { loading: regionsLoading } = useQuery(GET_REGIONS, {
    variables: {
      first: 100000,
      page: 1,
    },
    onCompleted(data) {
      let regions = data.regions;
      let regionsArray = [];
      regions.data.forEach((region, index) => {
        regionsArray.push({
          label: region?.name,
          value: region?.id,
        });
      });
      setRegionsDropDownData([...regionsArray]);
    },
    onError(err) {
      showNotification({
        color: "red",
        title: "Error",
        message: `${err}`,
      });
    },
  });

  useEffect(() => {
    if (
      location &&
      Object.keys(location) &&
      Object.keys(location)?.length > 0
    ) {
      setCenter({ lat: location.lat, lng: location.lng });
    }
  }, [location]);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GOOGLE_API_KEY,
    libraries,
  });

  const mapLoadHandler = (map) => {
    setMapRef(map);
  };

  const onPlaceChangedHandler = () => {
    if (autocomplete !== null) {
      setCenter({
        lat: autocomplete.getPlace().geometry.location.lat(),
        lng: autocomplete.getPlace().geometry.location.lng(),
      });
      setLocation({
        lat: autocomplete.getPlace().geometry.location.lat(),
        lng: autocomplete.getPlace().geometry.location.lng(),
      });
    }
  };

  const autocompleteLoadHandler = (autocomplete) => {
    setAutocomplete(autocomplete);
  };
  const form = useForm({
    initialValues: {
      business_email: "",
      business_phone_number: "",
      business_website: "",
      business_region_id: "2",
      business_zone: "",
      business_woreda: "",
      business_kebele: "",
      business_geo_location: {
        lat: null,
        lng: null,
      },
      owner_firstname: "",
      owner_middlename: "",
      owner_lastname: "",
      owner_phone_number: "",
    },
  });

  useEffect(() => {
    if (data) {
      form.setValues({
        business_email: data.business_email,
        business_phone_number: data.business_phone_number,
        business_website: data.business_website,
        business_zone: data.business_zone,
        owner_firstname: data.owner_firstname,
        owner_lastname: data.owner_lastname,
        owner_phone_number: data.owner_phone_number,
        business_kebele: data.business_kebele,
        business_woreda: data.business_woreda,
        owner_middlename: data.owner_middlename,
        business_region_id: data.business_region.id,
      });
      setLocation(data.business_geo_location);
    }
  }, [data]);
  const [updateBussiness, { loading: updateBussinessLoading }] = useMutation(
    UPDATE_BasicSupplierBusinessInfo
  );

  const { height } = useViewportSize();
  const submit = () => {
    const geoLocation =
      location && Object.keys(location).length > 0
        ? { lat: +location.lat, lng: +location.lng }
        : { lat: center.lat, lng: center.lng };
    let variables = {
      id: data.id,
      business_email: form.getInputProps("business_email").value,
      business_phone_number: form.getInputProps("business_phone_number").value,
      business_website: form.getInputProps("business_website").value,
      business_region_id: form.getInputProps("business_region_id").value,
      business_zone: form.getInputProps("business_zone").value,
      business_woreda: form.getInputProps("business_woreda").value,
      business_kebele: form.getInputProps("business_kebele").value,
      //business_geo_location: geoLocation,
      owner_firstname: form.getInputProps("owner_firstname").value,
      owner_middlename: form.getInputProps("owner_middlename").value,
      owner_lastname: form.getInputProps("owner_lastname").value,
      owner_phone_number: form.getInputProps("owner_phone_number").value,
    };
    updateBussiness({
      variables,
      onCompleted(data) {
        showNotification({
          color: "green",
          title: "Success",
          message: "Supplier business updated Successfully",
        });
        setOpened(false);
      },
      onError(error) {
        showNotification({
          color: "red",
          title: "Error",
          message:
            error?.graphQLErrors?.[0]?.message || "Failed to Update Business",
        });
      },
    });
  };

  const [activeTab, setActiveTab] = useState("business-info");
  const tabList = ["business-info", "business-address", "business-owner"];
  const nextTab = () => {
    const currentIndex = tabList.indexOf(activeTab);
    if (currentIndex < tabList.length - 1) {
      setActiveTab(tabList[currentIndex + 1]);
    }
  };

  const prevTab = () => {
    const currentIndex = tabList.indexOf(activeTab);
    if (currentIndex > 0) {
      setActiveTab(tabList[currentIndex - 1]);
    }
  };
  const setRegionDropDownValue = (val) => {
    form.setFieldValue("business_region_id", val);
  };
  return (
    <>
      <LoadingOverlay
        visible={updateBussinessLoading}
        color="blue"
        overlayBlur={2}
        loader={customLoader}
      />
      <ScrollArea style={{ height: height / 1.8 }} type="auto" offsetScrollbars>
        <form onSubmit={form.onSubmit(() => submit())} noValidate>
          <Tabs
            value={activeTab}
            onTabChange={setActiveTab}
            defaultValue="business-info"
            styles={{
              tabList: {
                borderBottom: `2px solid #FF6A00`,
              },
              tab: {
                "&[data-active]": {
                  borderColor: "#FF6A00",
                },
                "&:hover": {
                  borderColor: "#FF6A00",
                },
              },
            }}
          >
            <Tabs.List>
              <Tabs.Tab value="business-info">Business Information</Tabs.Tab>
              <Tabs.Tab value="business-address">Business Address</Tabs.Tab>
              <Tabs.Tab value="business-owner">
                Business Owner Information
              </Tabs.Tab>
            </Tabs.List>

            {/* Business Information Tab */}
            <Tabs.Panel value="business-info">
              <Grid gutter="md">
                <Grid.Col span={4}>
                  <TextInput
                    label="Business Email"
                    placeholder="Business Email"
                    {...form.getInputProps("business_email")}
                  />
                </Grid.Col>

                <Grid.Col span={4}>
                  <TextInput
                    required
                    label="Business Phone Number"
                    placeholder="Business Phone Number"
                    {...form.getInputProps("business_phone_number")}
                  />
                </Grid.Col>

                <Grid.Col span={4}>
                  <TextInput
                    label="Business Website"
                    placeholder="Business Website"
                    {...form.getInputProps("business_website")}
                  />
                </Grid.Col>
              </Grid>
            </Tabs.Panel>

            <Tabs.Panel value="business-address">
              <Grid>
                <Grid.Col span={4}>
                  <Select
                    required
                    searchable
                    data={regionsDropDownData}
                    value={form.getInputProps("business_region_id")?.value}
                    onChange={setRegionDropDownValue}
                    label="Region"
                    placeholder="Pick a region this Busines belongs to"
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <TextInput
                    required
                    label="Zone / Subcity"
                    placeholder="Zone / Subcity"
                    {...form.getInputProps("business_zone")}
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <TextInput
                    required
                    label="Woreda"
                    placeholder="Woreda"
                    {...form.getInputProps("business_woreda")}
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <TextInput
                    required
                    label="Kebele"
                    placeholder="Kebele"
                    {...form.getInputProps("business_kebele")}
                  />
                </Grid.Col>
              </Grid>
            </Tabs.Panel>
            <Tabs.Panel value="business-owner">
              <Grid>
                <Grid.Col span={4}>
                  <TextInput
                    required
                    label="First Name"
                    placeholder="First Name"
                    {...form.getInputProps("owner_firstname")}
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <TextInput
                    label="Middle Name"
                    placeholder="Middle Name"
                    {...form.getInputProps("owner_middlename")}
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <TextInput
                    required
                    label="Last Name"
                    placeholder="Last Name"
                    {...form.getInputProps("owner_lastname")}
                  />
                </Grid.Col>
              </Grid>
            </Tabs.Panel>
          </Tabs>
          <Grid>
            <Grid.Col span={12}>
              <Button
                onClick={prevTab}
                style={{
                  marginTop: "10px",
                  backgroundColor: "#FF6A00",
                  color: "#FFFFFF",
                }}
                disabled={activeTab === "business-info"}
              >
                Previous
              </Button>

              {activeTab !== "business-owner" ? (
                <Button
                  style={{
                    marginLeft: "14px",
                    marginTop: "10px",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  onClick={nextTab}
                >
                  Next
                </Button>
              ) : null}
              {activeTab === "business-owner" && (
                <Button
                  style={{
                    marginLeft: "10px",
                    marginTop: "10px",
                    backgroundColor: "#FF6A00",
                    color: "#FFFFFF",
                  }}
                  onClick={submit}
                  loading={updateBussinessLoading}
                >
                  Submit
                </Button>
              )}
            </Grid.Col>
          </Grid>
        </form>
      </ScrollArea>
    </>
  );
};

export default SupplierBusinessUpdateModal;
